import React from 'react';
import classNames from 'classnames';
import PropTypes, { node } from 'prop-types';
import keycode from 'keycode';
import { connect } from "react-redux";
import TableFooter from '@material-ui/core/TableFooter';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import Checkbox from 'material-ui/Checkbox';
import IconButton from 'material-ui/IconButton';
import { getFormattedDate, getTimeFromTimestamp } from "util/util";
import Tooltip from 'material-ui/Tooltip';
import DeleteIcon from 'material-ui-icons/Delete';
import FilterListIcon from 'material-ui-icons/FilterList';

let counter = 0;

function createData(name, calories, fat, carbs, protein) {
    counter += 1;
    return { id: counter, name, calories, fat, carbs, protein };
}

const columnData = [
    { id: 'nodeId', numeric: false, disablePadding: true, label: 'Device ID' },
    { id: 'status', numeric: false, disablePadding: false, label: 'Active Indicator' },
    { id: 'time', numeric: false, disablePadding: false, label: 'Last Seen' },
    { id: 'current1', numeric: false, disablePadding: true, label: 'Current 1' },
    { id: 'current2', numeric: false, disablePadding: false, label: 'Current 2' },
    { id: 'temperature1', numeric: false, disablePadding: false, label: 'Temperature 1' },
    { id: 'temperature2', numeric: false, disablePadding: false, label: 'Temperature 2' },
    { id: 'temperature3', numeric: false, disablePadding: false, label: 'Temperature 3' },
    { id: 'water', numeric: false, disablePadding: false, label: 'Water' },
    { id: 'lid', numeric: false, disablePadding: false, label: 'Lid' },
];

class EnhancedTableHead extends React.Component {
    static propTypes = {
        numSelected: PropTypes.number.isRequired,
        onRequestSort: PropTypes.func.isRequired,
        onSelectAllClick: PropTypes.func.isRequired,
        order: PropTypes.string.isRequired,
        orderBy: PropTypes.string.isRequired,
        rowCount: PropTypes.number.isRequired,
    };

    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };

    render() {
        const { onSelectAllClick, order, orderBy, numSelected, rowCount } = this.props;

        return (
            <TableHead>
                <TableRow>
                    {/* <TableCell padding="checkbox">
                        <Checkbox color="primary"
                                  indeterminate={numSelected > 0 && numSelected < rowCount}
                                  checked={numSelected === rowCount}
                                  onChange={onSelectAllClick}
                        />
                    </TableCell> */}
                    {columnData.map(column => {
                        return (
                            <TableCell
                                style={{
                                    background: '#E2E3E5'
                                }}
                                className={column.id !== 'deviceId' && "text-center"}
                                key={column.id}
                                numeric={column.numeric}
                                padding={column.disablePadding ? 'none' : 'default'}
                            >
                                <Tooltip
                                    title="Sort"
                                    placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === column.id}
                                        direction={order}
                                        onClick={this.createSortHandler(column.id)}
                                    >
                                        {column.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}


// let EnhancedTableToolbar = props => {
//     const { numSelected } = props;

//     return (
//         <Toolbar
//             className={classNames("table-header", {
//                 ["highlight-light"]: numSelected > 0,
//             })}
//         >
//             <div className="title">
//                 {numSelected > 0 ? (
//                     <Typography type="subheading">{numSelected} selected</Typography>
//                 ) : (
//                         <Typography type="title">Nutrition</Typography>
//                     )}
//             </div>
//             <div className="spacer" />
//             <div className="actions">
//                 {numSelected > 0 ? (
//                     <Tooltip title="Delete">
//                         <IconButton aria-label="Delete">
//                             <DeleteIcon />
//                         </IconButton>
//                     </Tooltip>
//                 ) : (
//                         <Tooltip title="Filter list">
//                             <IconButton aria-label="Filter list">
//                                 <FilterListIcon />
//                             </IconButton>
//                         </Tooltip>
//                     )}
//             </div>
//         </Toolbar>
//     );
// };

// EnhancedTableToolbar.propTypes = {
//     numSelected: PropTypes.number.isRequired,
// };


class EnhancedTable extends React.Component {
    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';
        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }
        let data = [];
        if (orderBy === 'nodeId' || orderBy === 'status') {
            data =
                order === 'desc'
                    ? this.state.data.sort((a, b) => (b[orderBy] < a[orderBy] ? -1 : 1))
                    : this.state.data.sort((a, b) => (a[orderBy] < b[orderBy] ? -1 : 1));
        }
        else {
            data =
                order === 'desc'
                    ? this.state.data.sort((a, b) => ((b.data && b.data.sensors && b.data.sensors[orderBy] !== undefined && b.data.sensors[orderBy]) < (a.data && a.data.sensors && a.data.sensors[orderBy] !== undefined && a.data.sensors[orderBy]) ? -1 : 1))
                    : this.state.data.sort((a, b) => ((a.data && a.data.sensors && a.data.sensors[orderBy] !== undefined && a.data.sensors[orderBy]) < (b.data && b.data.sensors && b.data.sensors[orderBy] !== undefined && b.data.sensors[orderBy]) ? -1 : 1));
        }
        this.setState({ data, order, orderBy });
    };
    handleSelectAllClick = (event, checked) => {
        if (checked) {
            this.setState({ selected: this.state.data.map(n => n.id) });
            return;
        }
        this.setState({ selected: [] });
    };
    handleKeyDown = (event, id) => {
        if (keycode(event) === 'space') {
            this.handleClick(event, id);
        }
    };
    handleClick = (event, deviceId) => {
        this.props.updateDeviceId(deviceId);
        // const { selected } = this.state;
        // const selectedIndex = selected.indexOf(id);
        // let newSelected = [];

        // if (selectedIndex === -1) {
        //     newSelected = newSelected.concat(selected, id);
        // } else if (selectedIndex === 0) {
        //     newSelected = newSelected.concat(selected.slice(1));
        // } else if (selectedIndex === selected.length - 1) {
        //     newSelected = newSelected.concat(selected.slice(0, -1));
        // } else if (selectedIndex > 0) {
        //     newSelected = newSelected.concat(
        //         selected.slice(0, selectedIndex),
        //         selected.slice(selectedIndex + 1),
        //     );
        // }

        // this.setState({ selected: newSelected });
    };
    handleChangePage = (event, page) => {
        // this.setState({ page });
        this.props.updateExtractData({
            data: this.state.data,
            pageNumber: page,
        })
    };
    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };
    isSelected = id => this.state.selected.indexOf(id) !== -1;

    constructor(props, context) {
        super(props, context);
        this.state = {
            order: 'asc',
            orderBy: 'calories',
            selected: [],
            data: props.dataExtract.data,
            page: props.dataExtract.pageNumber,
            rowsPerPage: 25,
        };
    }

    setData(dataExtract) {
        console.log('dataExtract: ', dataExtract);
        this.setState({
            data: dataExtract.data,
            page: dataExtract.pageNumber,
        })
    }

    componentWillReceiveProps(nextProps) {
        this.setData(nextProps.dataExtract);
    }

    checkWaterLevel = (threshold, water) => {
        let waterLevel = threshold.data && threshold.data.thresholds && threshold.data.thresholds.water;
        if (water < (waterLevel && waterLevel.min) || water > (waterLevel && waterLevel.max)) {
            return true;
        }
        return false;
    }

    checkTemperatureThreshold = (threshold, temperature) => {
        let temperatureThreshold = threshold.data && threshold.data.thresholds && threshold.data.thresholds.temperature;
        if (temperature < (temperatureThreshold && temperatureThreshold.min) || temperature > (temperatureThreshold && temperatureThreshold.max)) {
            return true;
        }
        return false;
    }

    checkCurrentThreshold = (threshold, current) => {
        if (current < threshold && threshold.min || current > threshold && threshold.max) {
            return true;
        }
        return false;
    }

    getdeviceOnline = (status) => {
        if (status === "ACTIVE") {
            return <img
                className="statusImage d-inline-block mx-2 pl-0"
                src="../../../../assets/images/online.png"
                alt="Online"
                style={{
                    borderRadius: 15,
                }}
            />;
        } else if (status === "INACTIVE") {
            return <img
                className="statusImage d-inline-block mx-2 pl-0"
                src="../../../../assets/images/redIc.png"
                alt="Offline"
                style={{
                    borderRadius: 15,
                }}
            />;
        }
        return <img
            className="statusImage d-inline-block mx-2 pl-0"
            src="../../../../assets/images/offline.png"
            alt="Offline"
            style={{
                borderRadius: 15,
            }}
        />;
    };

    render() {
        const { data, order, orderBy, selected, rowsPerPage, page } = this.state;
        return (
            <div className="w-100 px-2 device-catalogue">
                {/* <EnhancedTableToolbar numSelected={selected.length} /> */}
                <div className="flex-auto"
                    style={{
                        background: 'white'
                    }}>
                    <TableContainer className="table-responsive-material"
                        style={{
                            maxHeight: window.innerHeight - 240,
                        }}
                    >
                        <Table stickyHeader>
                            <EnhancedTableHead
                                numSelected={selected.length}
                                order={order}
                                orderBy={orderBy}
                                onSelectAllClick={this.handleSelectAllClick}
                                onRequestSort={this.handleRequestSort}
                                rowCount={data.length}
                            />
                            <TableBody>
                                {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(n => {
                                    const isSelected = this.isSelected(n.id);
                                    const status = n && n.status;
                                    const temperature1 = n.data && n.data.sensors && n.data.sensors.temperature1;
                                    const temperature2 = n.data && n.data.sensors && n.data.sensors.temperature2;
                                    const temperature3 = n.data && n.data.sensors && n.data.sensors.temperature3;
                                    const current1 = n.data && n.data.sensors && n.data.sensors.current1;
                                    const current2 = n.data && n.data.sensors && n.data.sensors.current2;
                                    const water = n.data && n.data.sensors && n.data.sensors.water;
                                    const lid = n.data && n.data.notification && n.data.notification.eventVal;
                                    let currentThreshold1 = n.data && n.data.thresholds && n.data.thresholds.current1;
                                    let currentThreshold2 = n.data && n.data.thresholds && n.data.thresholds.current2;
                                    return (
                                        <TableRow
                                            hover
                                            // onClick={event => this.handleClick(event, n.nodeId)}
                                            // onKeyDown={event => this.handleKeyDown(event, n.nodeId)}
                                            role="checkbox"
                                            aria-checked={isSelected}
                                            tabIndex={-1}
                                            key={n.id}
                                            selected={isSelected}
                                        >
                                            {/* <TableCell padding="checkbox">
                                                <Checkbox color="primary" checked={isSelected} />
                                            </TableCell> */}
                                            <TableCell padding="none"
                                                onClick={event => this.handleClick(event, n.nodeId)}
                                                onKeyDown={event => this.handleKeyDown(event, n.nodeId)}
                                                id="deviceId"
                                            >{n.nodeId}</TableCell>
                                            <TableCell className="text-center">
                                                <Tooltip
                                                    title={`Status: ${status === "UNKNOWN" ? "NEVER ACTIVE" : status}`}
                                                    placement={'bottom-end'}
                                                >
                                                    {this.getdeviceOnline(status)}
                                                </Tooltip>
                                            </TableCell>
                                            <TableCell className="text-center">{n.data && n.data.sensors && getFormattedDate(n.data.sensors.time)}</TableCell>
                                            <TableCell
                                                className="text-center"
                                                style={{
                                                    border: this.checkCurrentThreshold(currentThreshold1, current1) && '1px solid rgb(226, 227, 229)',
                                                    background: this.checkCurrentThreshold(currentThreshold1, current1) && 'red'
                                                }}
                                            >{current1}</TableCell>
                                            <TableCell className="text-center"
                                                style={{
                                                    border: this.checkCurrentThreshold(currentThreshold2, current2) && '1px solid rgb(226, 227, 229)',
                                                    background: this.checkCurrentThreshold(currentThreshold2, current2) && 'red'
                                                }}
                                            >{current2}</TableCell>
                                            <TableCell
                                                className="text-center"
                                                style={{
                                                    border: this.checkTemperatureThreshold(n, temperature1) && '1px solid rgb(226, 227, 229)',
                                                    background: this.checkTemperatureThreshold(n, temperature1) && 'red'
                                                }} >
                                                {temperature1}
                                            </TableCell>
                                            <TableCell
                                                className="text-center"
                                                style={{
                                                    border: this.checkTemperatureThreshold(n, temperature2) && '1px solid rgb(226, 227, 229)',
                                                    background: this.checkTemperatureThreshold(n, temperature2) && 'red'
                                                }}>
                                                {temperature2}
                                            </TableCell>
                                            <TableCell
                                                className="text-center"
                                                style={{
                                                    border: this.checkTemperatureThreshold(n, temperature2) && '1px solid rgb(226, 227, 229)',
                                                    background: this.checkTemperatureThreshold(n, temperature3) && 'red'
                                                }}>
                                                {temperature3}
                                            </TableCell>
                                            <TableCell
                                                className="text-center"
                                                style={{
                                                    border: this.checkWaterLevel(n, water) && '1px solid rgb(226, 227, 229)',
                                                    background: this.checkWaterLevel(n, water) && 'red'
                                                }}>
                                                {water}
                                            </TableCell>
                                            <TableCell
                                                className="text-center"
                                                style={{
                                                    border: lid === 'Open' && '1px solid rgb(226, 227, 229)',
                                                    background: lid === 'Open' && 'red'
                                                }}>{lid}</TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        style={{
                            width: window.innerWidth,
                        }}
                        count={data.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onChangePage={this.handleChangePage}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    />
                </div>
            </div>
        );
    }
}



const mapStateToProps = ({ symbioticReducer }) => {
    return {
      deviceId: symbioticReducer.deviceId,
      dataExtract: symbioticReducer.dataExtract,
    };
  };
  
  const mapDispatchToProps = (dispatch) => {
    return {
      updateDeviceId: (id) => {
        dispatch({ type: "UPDATE_DEVICE_ID", deviceId: id });
      },
      updateExtractData: (data) => {
        dispatch({ type: "EXTRACT_DATA", dataExtract: data });
      },
    }
  };

export default connect(mapStateToProps, mapDispatchToProps)(EnhancedTable);


// WEBPACK FOOTER //
// ./app/routes/dataExtract/EnhancedTable.js